import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
             document.body.style.overflow = '';
        }
    }, [isOpen]);

    const closeMenu = () => {
        if (isOpen) setIsOpen(false);
    }

    return (
        <header className="fixed w-full top-0 z-50 bg-white border-b border-gray-100 transition-all duration-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <div className="flex-shrink-0 flex items-center">
                        <a href="/" className="flex items-center gap-3 group">
                            <img src="/assets/images/logo-horizontal-dark.png" alt="Trustpoint"
                                className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
                        </a>
                    </div>

                    <nav className="hidden md:flex space-x-8 items-center">
                        <a href="#dashboard"
                            className="text-sm font-light text-gray-600 hover:text-secondary transition-all duration-300">Platform</a>
                        <a href="#process"
                            className="text-sm font-light text-gray-600 hover:text-secondary transition-all duration-300">Process</a>
                        <a href="#success"
                            className="text-sm font-light text-gray-600 hover:text-secondary transition-all duration-300">Success Stories</a>
                        <a href="#about"
                            className="text-sm font-light text-gray-600 hover:text-secondary transition-all duration-300">About Us</a>
                        <a href="#contact"
                            className="btn-primary-md">
                            Free Financial Audit
                        </a>
                    </nav>

                    <div className="flex items-center md:hidden">
                        <button type="button" onClick={toggleMenu}
                            className="mobile-menu-toggle inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none transition-all duration-300">
                            <span className="sr-only">Open main menu</span>
                            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            <div id="mobile-menu"
                className={`${isOpen ? 'block' : 'hidden'} md:hidden fixed inset-x-0 bottom-0 top-20 z-50 bg-white border-t border-gray-100 p-8 shadow-2xl`}
                style={{ backgroundColor: '#FFFFFF', opacity: 1 }}>
                <nav className="flex flex-col space-y-6 h-full">
                    <a href="#dashboard" onClick={closeMenu}
                        className="mobile-link text-sm font-light text-secondary hover:text-accent transition-all duration-300">Platform</a>
                    <a href="#process" onClick={closeMenu}
                        className="mobile-link text-sm font-light text-secondary hover:text-accent transition-all duration-300">Process</a>
                    <a href="#success" onClick={closeMenu}
                        className="mobile-link text-sm font-light text-secondary hover:text-accent transition-all duration-300">Success Stories</a>
                    <a href="#about" onClick={closeMenu}
                        className="mobile-link text-sm font-light text-secondary hover:text-accent transition-all duration-300">About Us</a>

                    <div className="pt-8">
                        <a href="#contact" onClick={closeMenu}
                            className="mobile-link btn-primary-md w-full">
                            Free Financial Audit
                        </a>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
